define('CustomBowls.EntryPoint', [
  'CustomBowls.View',
  'Header.Menu.View',
  'underscore'
], function (
  CustomBowlsView,
  HeaderMenuView,
  _
) {
  'use strict';

  // Rewrites every menu entry whose href contains categoryFragment so it points to
  // redirectUrl (the external bowl configurator). Recurses into sub-categories.
  function rewriteRedirectLinks(entries, categoryFragment, redirectUrl) {
    if (!entries || !entries.length) {
      return;
    }

    for (var i = 0; i < entries.length; i++) {
      var entry = entries[i];
      if (!entry) {
        continue;
      }

      if (entry.href && entry.href.indexOf(categoryFragment) !== -1) {
        entry.href = redirectUrl;
        entry.data.hashtag = redirectUrl;
        entry.data.touchpoint = 'external';
        delete entry['data-type'];
      }

      rewriteRedirectLinks(entry.categories, categoryFragment, redirectUrl);
    }
  }

  return {
    mountToApp: function mountToApp(container) {
      var pageType = container.getComponent('PageType');

      if (pageType) {
        pageType.registerPageType({
          name: 'custombowl',
          routes: ['custombowl'],
          view: CustomBowlsView,
          options: {
            container: container
          }
        });
      }

      var environment = container.getComponent('Environment');
      var configuration = (environment && environment.getConfig('customBowls')) || {};
      var categoryFragment = configuration.categoryFragment;
      var redirectUrl = configuration.redirectUrl;

      // Only rewrite menu links when both the fragment to match and its destination
      // are configured on the Configuration record.
      if (!categoryFragment || !redirectUrl) {
        return;
      }

      _.extend(HeaderMenuView.prototype, {
        getContext: _.wrap(HeaderMenuView.prototype.getContext, function (fn) {
          var context = fn.apply(this, _.toArray(arguments).slice(1));
          rewriteRedirectLinks(context.categories, categoryFragment, redirectUrl);
          return context;
        })
      });
    }
  };
});
